<template>
    <div>
        <CustomSelect
            v-bind="$props"
            :itemComponent="component"
            :value="icon"
            @input="handleIcon"
            :options="icons"
        >
            <div slot="selectedLabel" class="selected-icon">
                <span v-if="!value">Sélectionnez une icône</span>
                <font-awesome-icon v-if="icon.id" :icon="icon.id" class="icon fa-lg" />
                <span class="selected">{{ icon.text }}</span>
            </div>
        </CustomSelect>
    </div>
</template>

<script>
import CustomSelect from './Select';
import { fas } from '@fortawesome/free-solid-svg-icons';

const ICONS = Object.values(fas).map((v) => ({
    id: v.iconName,
    text: v.iconName,
}));

export default {
    props: {
        ...CustomSelect.props,
        value: {
            type: String,
        },
    },
    data() {
        return {
            component: () => import('./SelectItemIcon'),
            icons: ICONS,
            icon: this.convertIcon(),
        };
    },
    watch: {
        value() {
            this.icon = this.convertIcon();
        },
    },
    methods: {
        convertIcon() {
            const iconName = this.value || '';
            return {
                id: iconName,
                text: iconName,
            };
        },
        handleIcon(event) {
            this.$emit('input', event.text);
        },
    },
    components: {
        CustomSelect,
    },
};
</script>

<style lang="scss">
.dropdown-toggle {
    .selected-icon {
        display: inline-block;
        color: #8e919b;

        .icon,
        .selected {
            color: #3b3e47;
        }

        // span {
        //     vertical-align: middle;

        //     &.color-pill {
        //         border-radius: 50%;
        //         width: 18px;
        //         height: 18px;
        //         align-self: center;
        //         display: inline-block;
        //         margin-right: 9px;
        //     }
        // }
    }
}
</style>
